import React from 'react';
import '../styles/GetInTouch.css';

const GetInTouch: React.FC = () => {
  return (
    <section className="get-in-touch">
      <div className="container">
        <h2 className="section-title">Get in Touch</h2>
        
        <p className="section-description">
          Have questions about our solutions? Need help getting started? We're here to help.
        </p>
        
        <div className="contact-section">
          <h3 className="contact-heading">Contact Information</h3>
          <p className="contact-instruction">
            Fill out the form and we'll get back to you within 24 hours.
          </p>
          
          <div className="contact-details">
            <a href="mailto:info@gordiananalytics.com" className="contact-item">
              <div className="contact-icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#b0b0b0" strokeWidth="2">
                  <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
                  <polyline points="22,6 12,13 2,6"/>
                </svg>
              </div>
              <div className="contact-info">
                <h4 className="contact-label">Email</h4>
                <p className="contact-value">info@gordiananalytics.com</p>
              </div>
            </a>
            
            <div className="contact-item">
              <div className="contact-icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#b0b0b0" strokeWidth="2">
                  <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/>
                  <circle cx="12" cy="10" r="3"/>
                </svg>
              </div>
              <div className="contact-info">
                <h4 className="contact-label">Office</h4>
                <p className="contact-value">Lausanne, 1004<br/>Switzerland</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default GetInTouch;
